import { useTranslation } from 'react-i18next';
import styles from './Tab.module.less'

const Index = ({ active, onChange }) => {
  const { t } = useTranslation()

  return (
    <div className={styles.newsTab}>
      <div className="mod">
        {
          ['allNews', 'gameNews', 'companyNews'].map((item, index) => (
            <a 
              key={item} 
              className={ active === index ? styles.active : ''} 
              href="#a"
              onClick={ e => { 
                e && e.preventDefault();
                onChange(index);
              }}
              >
                {t(item)}
            </a>
          ))
        }
      </div>
    </div>
  )
}

export default Index
